module.exports = __webpack_public_path__ + "img/icon-warning-skogbrannfare-3.40d0cea9.svg";